module.exports = __webpack_public_path__ + "img/77.7bf0bf12.png";